import { combineReducers } from 'redux';
// 用来存放容器资源准备情况，wx签名准备情况
import {
  GLOBAL_CONFIG_SUCCESS
} from "@/action-types/userInfo";

const globalConfig = (state = {}, action) => {
  if (action.type === GLOBAL_CONFIG_SUCCESS) {
    return { ...state, ...action.data }
  }
  return state
}

export default combineReducers({
  globalConfig: globalConfig
})
